<template>
    <div id="talk-publish-we-chat">
        <van-nav-bar
                left-text="取消"
                right-text="发布"
                @click-left="$router.go(-1)"
                @click-right="onPublish"
        >
        </van-nav-bar>
        <van-cell-group id="content">
            <van-field v-model="form.content" type="textarea" :autosize="{ maxHeight: 250, minHeight: 80 }"
                       placeholder="说说你的心情吧..."/>
        </van-cell-group>
        <div class="album">
            <img v-for="(image, key) in form.album" :key="key" v-lazy="image + '?imageView2/1/w/200/h/200'"
                 @click="onDelete(key)"/>
            <!--<van-uploader :after-read="onAdd" multiple>-->
            <span class="play" v-if="form.video"><i class="iconfont icon-bofang1"></i></span>

            <img src="http://img.tutubox.cn/talk-add@2x.png?imageView2/1/w/200/h/200"
                 @click="addChooseImageShow = true"/>
            <!--</van-uploader>-->
        </div>
        <van-popup v-model="addChooseImageShow" position="bottom" >
            <!-- <van-cell-group id="choose-image">
                <van-cell value="用相机拍摄" :center = true @click="onChooseImage(['camera'])"/>
                <van-cell value="从相册选择" :center = true @click="onChooseImage(['album'])"/>
                <van-cell value="取消" :center = true  @click="addChooseImageShow = false"></van-cell>
            </van-cell-group> -->
            <div class="popup-content">
                <div @click="onChooseImage(['camera'])" class="popup-first">拍摄</div>
                <div @click="onChooseImage(['album'])" class="popup-second">从手机相册选择</div>
                <!-- <upload-video @receptionVframe="receptionVframe"></upload-video> -->

                <div @click="addChooseImageShow = false" class="popup-third">取消</div>
            </div>
            
        </van-popup>
    </div>
</template>

<script>
    // import * as qiNiu from 'qiniu-js';
    // import HtmlImageCompress from '@/components/HtmlImageCompress';
    import store from '@/store';
    import {NavBar, CellGroup, Cell, Field, Lazyload, Toast, Dialog, Popup} from 'vant';
    import UploadVideo from '@/components/UploadVideo'

    import {Voucher} from '@/api/wechat';
    // import VConsole from 'vconsole';

    const LazyloadOptions = {
        // loading: 'http://img.tutubox.cn/talk-sitg1.png?imageView2/1/w/200/h/200',
        loading: 'http://img.tutubox.cn/yuanquanwenzi.jpg?imageView2/1/w/200/h/200',
        // error: 'http://img.tutubox.cn/talk-sitg1.png?imageView2/1/w/100/h/100',
        // preload: 'http://img.tutubox.cn/talk-sitg1.png?imageView2/1/w/200/h/200',
        preload: 'http://img.tutubox.cn/yuanquanwenzi.jpg?imageView2/1/w/200/h/200'

    };
    import Vue from 'vue'
    Vue.use(NavBar).use(CellGroup).use(Field).use(Lazyload, LazyloadOptions).use(Toast).use(Dialog).use(Popup).use(Cell);

    export default {
        name: 'TalkPublishWeChat',

        data() {
            return {
                addChooseImageShow: false,
                form: {
                    content: '',
                    album: [],
                    video: ''
                },
                queueUpload: [
                    // {
                    //   index: 0,
                    //   name: '',
                    //   upload: 0,//0加入，1正在上传， 2完成上传
                    //   url: ''
                    // }
                ],
                wx: null
            };
        },

        components: { UploadVideo },

        methods: {
            onChooseImage(sourceType = ['album', 'camera']) {
                this.addChooseImageShow = false;
                let app = this;
                this.wx.chooseImage({
                    count: 9, // 默认9
                    sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
                    sourceType, // 可以指定来源是相册还是相机，默认二者都有
                    success(res) {
                        let localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                        app.onAdd(localIds);
                        // console.log('localIds', res);
                    }
                });
            },
            onPublish() {
                if (!this.form.content.length) {
                    Toast('心情不能为空哦~');
                    return;
                }
                if (this.form.content.length > 250) {
                    Toast('心情不能超过250字哦~');
                    return;
                }
                if (!this.form.album.length) {
                    Toast('至少需要上传一张图片~');
                    return;
                }
                this.$http.post('/talk/create', this.form).then(() => {
                    Toast('发布成功~');
                    this.form.content = '';
                    this.form.album = [];
                    this.queueUpload = [];
                    this.$router.replace('/wxapp');
                });
            },
            onDelete(key) {
                if(this.form.video) {
                    Dialog.confirm({
                        message: '确认删除视频?'
                    }).then(() => {
                        this.form.album.splice(key, 1);
                        this.form.video = ''
                    }).catch(() => {
                    })
                }else {
                    Dialog.confirm({
                        message: '确认删除图片?'
                    }).then(() => {
                        this.form.album.splice(key, 1);
                        this.queueUpload.splice(key, 1);
                    }).catch(() => {
                    });
                }
            },
            onAdd(files) {
                files.forEach((file) => {
                    let exist = false;
                    this.queueUpload.forEach((_item) => {
                        if (file === _item.name) {
                            exist = true;
                            return false;
                        }
                    });
                    if (!exist) {
                        let task = {
                            index: 0,
                            name: file,
                            status: 0,//0加入，1正在上传， 2完成上传
                            url: ''
                        };
                        // let index = this.queueUpload.push(task);
                        // this.queueUpload[index - 1].index = index;
                        task.index = this.queueUpload.push(task);
                        // this.upload(task, file);
                    }
                });
                // console.log('queueUpload', this.queueUpload);
                this.onQueue();
            },
            onQueue() {
                // this.queueUpload.forEach(task => {
                //     if (task.status === 0) {
                //         this.upload(task, task.name);
                //         return false;
                //     }
                // })
                let task = this.queueUpload.shift();
                if (task) {
                    this.upload(task, task.name);
                }
            },
            upload(task, file) {
                if (task.status !== 0 || this.form.album.length > 9) {
                    return;
                }
                let app = this;
                // console.log('task', task);
                task.status = 1;
                this.wx.uploadImage({
                    localId: file, // 需要上传的图片的本地ID，由chooseImage接口获得
                    isShowProgressTips: 1, // 默认为1，显示进度提示
                    success(res) {
                        let serverId = res.serverId; // 返回图片的服务器端ID
                        // console.log('serverId', res);
                        app.$http.get('/wechat/download', {params: {serverId}}).then(({url}) => {
                            task.status = 2;
                            task.url = url;
                            app.form.album.push(task.url);
                        }).catch((err) => {
                            // 处理失败会执行
                            this.queueUpload.splice(task.index - 1, 1);
                            Toast('处理图像异常了,请重试~');
                            console.log(err);
                        });
                        setTimeout(() => {
                            app.onQueue();
                        }, 200);
                    }
                });
            },
            receptionVframe(vframe, video) {
                this.addChooseImageShow = false
                this.form.album.push(vframe)
                this.form.video = video
                console.log(vframe);
                console.log(video);
            }
        },

        activated() {
            Voucher(`${window.location.href.split('#')[0]}`, 'chooseImage,previewImage,uploadImage,downloadImage').then(_wx => {
                this.wx = _wx;
            });
        },

        created() {
            store.dispatch('RefreshUserInfo');
            // let vConsole = new VConsole({});
        }
    };
</script>

<style scoped lang="less">
    #talk-publish-we-chat {
        /deep/ .van-nav-bar {
            border-bottom: 1px solid #eee;
        }
        /deep/ .van-nav-bar__left .van-nav-bar__text {
            color: black;
            font-size: 16px;
        }
        /deep/ .van-nav-bar__right .van-nav-bar__text {
            color: #bea473;
            font-size: 16px;
        }
        #content /deep/ [class*=van-hairline]::after {
            content: none;
        }
        .album {
            display: flex;
            justify-content: left;
            flex-flow: row wrap;
            padding: 0 15px;
            position: relative;
            > img {
                margin-right: 4px;
                margin-bottom: 4px;
                width: 100px;
                height: 100px;
            }
            .play{
                position: absolute;
                top: 28px;
                left: 43px;
                .iconfont{
                    font-size: 40px;
                    color: #fff;
                }
            }
        }
        /deep/ [class*=van-hairline]::after {
            border: none;
        }
        // #choose-image {
        //     /deep/ .van-cell {
        //         padding: 5px 15px;
        //         padding-right: 90px;
        //         border-bottom: 1px solid #ccc;
        //     }
        // }

        .popup-content{
            div{
                text-align: center;
                height: 50px;
                line-height: 50px;
                background-color: #fff;
                font-size: 18px;
            }
            .popup-first{
                border-bottom: 1px solid #dad5db;
            }
            .popup-second{
                border-bottom: 1px solid #dad5db;
            }
        }
    }
</style>